import { getFormLabel } from '@/helpers';
// Forms validators functions
const passwordValidation = (ref, fieldSchema, password, passwordConfirmation) => {
  const formFields = ref;

  if (fieldSchema === 'password' && passwordConfirmation && passwordConfirmation.length > 0) {
    const passwordConfirmationField = formFields.find(c => c.field.model === 'passwordConfirmation');
    passwordConfirmationField.validate();
  } else if (fieldSchema === 'passwordConfirmation' && password && password.length > 0) {
    const passwordField = formFields.find(c => c.field.model === 'password');
    passwordField.validate();
  }
};

const togglePasswordVisibility = (formFields, fieldSchema) => {
  // Show/hide password
  let f = formFields.find(f => f.field.model === fieldSchema);
  if (f.field.inputType === 'password') {
    f.field.inputType = 'text';
    f.field.buttons[0].classes = 'button toggle-visibility text has-visibility';
  } else {
    f.field.inputType = 'password';
    f.field.buttons[0].classes = 'button toggle-visibility text';
  }
};

const addressValidation = value => {
  let address = {};

  if (value) {
    address = {
      country: value.country,
      latitude: value.latitude,
      locality: value.locality,
      longitude: value.longitude,
      postalCode: value.postal_code,
      route: value.route,
      streetNumber: value.street_number
    };
  } else {
    address = {};
  }

  return address;
};

const validateField = (formFields, modelKey) => {
  formFields.find(f => f.field.model === modelKey).validate();
};

const textCounter = (inputValue, maxLength) => {
  return inputValue ? `${inputValue.length}/${maxLength}` : `0/${maxLength}`;
};

const mobilityOptions = activityField => {
  let options = getFormLabel('mobility', 'options');
  return activityField === 'passenger_transport'
    ? (options = options.concat(getFormLabel('mobility', 'passenger_transport_options')))
    : options;
};

export { addressValidation, passwordValidation, textCounter, togglePasswordVisibility, validateField, mobilityOptions };
